import React from 'react'

import Input from '../../../components/Input/Input'
import TextEditor from '../../../components/TextEditor/TextEditor'

const FormInputsSr = ({ errors, status, touched, isSubmitting, values, setFieldValue }) => {
    const { title, text } = values

    return (
        <>
            <Input
                name="title"
                id="title"
                type="text"
                errors={errors}
                touched={touched}
                label="Naslov"
                setFieldValue={setFieldValue}
                value={title}
            />
            <TextEditor data={text} setFieldValue={setFieldValue} label="Tekst" name="text" />
        </>
    )
}

export default FormInputsSr
